<ng-container>
  <div mat-dialog-title>
    <span>
      <ng-container *ngIf="!(loading$ | async); else titleSpinner">
        {{ title | translate: {name: customView.name} }}
      </ng-container>
      <ng-template #titleSpinner>
        <app-title-spinner></app-title-spinner>
      </ng-template>
    </span>

    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <q9-content-loader [isLoading]="loading$ | async"></q9-content-loader>

  <ng-container *ngIf="!(loading$ | async)">
    <div class="edit-custom-view-dialog">
      <app-select-columns-view
        [confirmBtn]="'GENERAL.CONFIRM_BTN'"
        [cancelBtn]="'POPUPS.CANCEL'"
        (confirmColumnsSelect)="updateCustomView($event)"
        (cancelColumnsSelect)="close()"></app-select-columns-view>
    </div>
  </ng-container>
</ng-container>
